// extracted by mini-css-extract-plugin
export default {"emptyRow":"style_emptyRow__Zz1aI"};